import { Theme } from "@material-ui/core/styles";
import { CSSProperties } from "@material-ui/core/styles/withStyles";

export const styles = (theme: Theme): Record<string, CSSProperties> => ({
    bold: {
      fontWeight: "bold",
    },
    border: {
      borderColor: "#d6d7da",
      borderRadius: 4,
      borderStyle: "solid",
      borderWidth: 1,
      width: theme.spacing(1) * 4,
    },
    bottomButton: {
      marginTop: theme.spacing(1),
    },
    button: {
      marginBottom: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    header: {
      marginTop: 30,
    },
    notSubmitted: {
      "&:hover": {
        backgroundColor: "darkGreen",
      },
      backgroundColor: "green",
      color: "white",
    },
    paper: {
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(1),
      padding: theme.spacing(1),
    },
    submitted: {
      "&:hover": {
        backgroundColor: "darkGreen",
      },
      backgroundColor: "green",
      color: "white",
    },
    summaryBox: {
      backgroundColor: "#efefef",
      border: "1px solid #424242",
      borderRadius: 4,
      padding: `${theme.spacing(1)}px ${theme.spacing(1)}px ${theme.spacing(
        1
      )}px ${theme.spacing(1)}px`,
    },
    table: {
      marginBottom: theme.spacing(1) * 2,
    },
    text: {
      overflowWrap: "break-word",
      whiteSpace: "pre-wrap",
    },
    textInput: {
      width: "100%",
    },
  });


// WEBPACK FOOTER //
// ./src/features/director/pages/EvaluationPage/styles.ts